import * as React from 'react'
import './makeSvgSprite'

export interface IIconProps {
  name: string
  alt?: string
  iconClass?: string
}

const Icon = ({ name, alt, iconClass }: IIconProps) => {
  return (
    <svg
      className={`Icon Icon-${name} ${iconClass ? iconClass : ''}`}
      aria-hidden={alt ? 'false' : 'true'}
    >
      {alt ? <title>{alt}</title> : ''}
      <use xlinkHref={`#${name}`} />
    </svg>
  )
}

export default Icon



// WEBPACK FOOTER //
// ./src/components/Icon/Icon.tsx